'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _video = require('video.js');

var _video2 = _interopRequireDefault(_video);

var _Modal = require('../Modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _ContentCardVideo = require('./ContentCardVideo.css');

var _ContentCardVideo2 = _interopRequireDefault(_ContentCardVideo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * Include the videojs css files locally in your project.
 * These were left out because of compilation issues with NextJS in thescore-web
 * 'video.js/dist/video-js.css'
 */

var ContentCardVideo = function (_Component) {
  _inherits(ContentCardVideo, _Component);

  function ContentCardVideo(props) {
    _classCallCheck(this, ContentCardVideo);

    var _this = _possibleConstructorReturn(this, (ContentCardVideo.__proto__ || Object.getPrototypeOf(ContentCardVideo)).call(this, props));

    _this.state = { modalOpen: false, portrait: false, height: null };
    _this.handleCloseClick = _this.handleCloseClick.bind(_this);
    _this.handleOverlayClick = _this.handleOverlayClick.bind(_this);
    _this.handleKeyPress = _this.handleKeyPress.bind(_this);
    return _this;
  }

  _createClass(ContentCardVideo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (!this.videoNode) {
        return;
      }

      // Change text
      /* eslint-disable */
      var bigPlayButton = _video2.default.getComponent('BigPlayButton');
      var customButton = _video2.default.extend(bigPlayButton, {
        constructor: function constructor() {
          bigPlayButton.apply(this, arguments);
          this.controlText('Play Video - externally sourced content');
        }
      });
      /* eslint-enable */

      _video2.default.registerComponent('BigPlayButton', customButton);

      this.player = (0, _video2.default)(this.videoNode, {
        sources: [{
          src: this.props.src
        }],
        controls: true,
        fluid: true,
        poster: this.props.poster,
        preload: 'none'
      });

      // For portrait videos ensure there are black bars and height is limited
      this.player.on('loadedmetadata', function () {
        if (_this2.player.videoHeight() >= _this2.player.videoWidth()) {
          _this2.player.el().classList.add('vjs-4-3');
          _this2.setState({ portrait: true });
        }
      });

      // disable right clicking video to prevent downloads
      this.player.on('contextmenu', function (e) {
        e.preventDefault();
      });

      if (this.props.modalEnabled) {
        this.player.on('play', function () {
          _this2.setState({
            modalOpen: true,
            videoPlayed: true
          });
          _this2.props.onPlayCallback();
        });
        this.player.on('pause', function () {
          _this2.props.onStopCallback();
        });
        this.player.on('ended', function () {
          _this2.props.onStopCallback();
        });
      }

      if (this.props.trackEvent) {
        this.player.on('play', function () {
          _this2.props.trackEvent(_this2.props.type + '_video_play', {});
          window.dispatchEvent(new Event('image-loaded'));
          _this2.props.onPlayCallback();
        });
        this.player.on('pause', function () {
          if (_this2.player.currentTime() !== _this2.player.duration()) {
            _this2.props.trackEvent(_this2.props.type + '_video_pause', {});
          }
        });
        this.player.on('ended', function () {
          _this2.props.trackEvent(_this2.props.type + '_video_end', {});
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.src !== nextProps.src && this.player) {
        this.player.poster(nextProps.poster);
        this.player.src(nextProps.src);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.player) this.player.dispose();
    }
  }, {
    key: 'handleCloseClick',
    value: function handleCloseClick() {
      var _this3 = this;

      if (this.player) this.player.pause();
      this.setState({ modalOpen: false }, function () {
        _this3.setState({ height: _this3.player.currentHeight() + 5 });
        window.dispatchEvent(new Event('image-loaded'));
      });
    }
  }, {
    key: 'handleOverlayClick',
    value: function handleOverlayClick() {
      window.open(this.props.url, '_blank').focus();
    }
  }, {
    key: 'handleKeyPress',
    value: function handleKeyPress(event) {
      if (event.key === 'Enter') {
        this.handleOverlayClick();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      return _react2.default.createElement(
        'div',
        null,
        this.props.viewOnExternalSite ? _react2.default.createElement('div', {
          className: 'linkOverlay',
          role: 'button',
          tabIndex: '0',
          onClick: this.handleOverlayClick,
          onKeyPress: this.handleKeyPress,
          title: 'Watch video on external site'
        }) : null,
        _react2.default.createElement('div', { className: 'topGradient' }),
        _react2.default.createElement(
          _Modal2.default,
          {
            modalOpen: this.state.modalOpen,
            handleCloseClick: this.handleCloseClick,
            portrait: this.state.portrait
          },
          _react2.default.createElement(
            'div',
            { 'data-vjs-player': true },
            _react2.default.createElement('video', {
              ref: function ref(node) {
                _this4.videoNode = node;
              },
              className: 'video-js vjs-big-play-centered'
            }),
            _react2.default.createElement('div', { className: !this.state.videoPlayed ? 'bottomGradient' : '' })
          )
        ),
        _react2.default.createElement(_style2.default, {
          styleId: _ContentCardVideo2.default.__hash,
          css: _ContentCardVideo2.default
        })
      );
    }
  }]);

  return ContentCardVideo;
}(_react.Component);

ContentCardVideo.propTypes = {
  onPlayCallback: _propTypes2.default.func,
  onStopCallback: _propTypes2.default.func,
  poster: _propTypes2.default.string.isRequired,
  src: _propTypes2.default.string.isRequired,
  type: _propTypes2.default.string.isRequired,
  url: _propTypes2.default.string,
  trackEvent: _propTypes2.default.func,
  modalEnabled: _propTypes2.default.bool,
  viewOnExternalSite: _propTypes2.default.bool
};

ContentCardVideo.defaultProps = {
  onPlayCallback: function onPlayCallback() {},
  onStopCallback: function onStopCallback() {},
  trackEvent: null,
  modalEnabled: false,
  viewOnExternalSite: false,
  url: ''
};

exports.default = ContentCardVideo;